import React, { FC } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  HStack,
  Text,
  Badge,
  Box,
  Divider,
} from '@chakra-ui/react'

interface FeatureFlagsModalProps {
  isOpen: boolean
  onClose: () => void
  userEmail: string
  featureFlags: Record<string, boolean>
}

const FeatureFlagsModal: FC<FeatureFlagsModalProps> = ({
  isOpen,
  onClose,
  userEmail,
  featureFlags,
}) => {
  const getFlagBadgeColor = (value: boolean) => {
    return value ? 'green' : 'red'
  }

  const getFlagBadgeText = (value: boolean) => {
    return value ? 'Enabled' : 'Disabled'
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Feature Flags - {userEmail}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={4} align="stretch">
            {Object.keys(featureFlags).length === 0 ? (
              <Text color="#A7A7A7" textAlign="center" py={4}>
                No feature flags available
              </Text>
            ) : (
              Object.entries(featureFlags).map(([flagName, flagValue]) => (
                <Box key={flagName}>
                  <HStack justify="space-between" align="center">
                    <Text fontSize="sm" color="#585858" fontWeight="500">
                      {flagName}
                    </Text>
                    <Badge colorScheme={getFlagBadgeColor(flagValue)}>
                      {getFlagBadgeText(flagValue)}
                    </Badge>
                  </HStack>
                  <Divider mt={2} />
                </Box>
              ))
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default FeatureFlagsModal
